import Model from "../OBJRep/Model";
import Resource from "../OBJRep/Resource";
import { authenticateUrl, toDataURL } from "./Utils";
import ResourceSearchResult from "../OBJRep/ResourceSearchResult";
/*
  SERVICE RESPONSIBLE TO INTERACT WITH RESOURCES SERVER
*/

const APP_DOMAIN = process.env.REACT_APP_DOMAIN;
const RESOURCES_BASE_URL = process.env.REACT_APP_RESOURCES_BASE_URL;

export const ENCARTE_MODEL_CATEGORY = "ENCARTE_MODEL";
export const OTHER_CATEGORY = "OTHER";
export const PRODUCT_CATEGORY = "PRODUCT";
export const LOGO_CATEGORY = "LOGO";

export const retrieveResources = async (
  token,
  query,
  category,
  page = 0,
  size = 10
) => {
  const params = new URLSearchParams();
  params.append("category", category);
  params.append("page", page);
  params.append("size", size);
  params.append("query", query);
  const url = `${RESOURCES_BASE_URL}/files/search?` + params.toString();
  const res = await fetch(url, {
    headers: { Authorization: token },
  });

  if (!res.ok) return ResourceSearchResult([], true, 0, false);
  const result = await res.json();
  return getResourceSearchResult(token, result);
};

export async function getResourceSearchResult(token, result) {
  try {
    let resources = result.resources;
    const links = await Promise.all(
      resources.map((f) => {
        return toDataURL(f.location + "/", token);
      })
    );

    resources = resources.map((f, i) => {
      return Resource(links[i], f.location + "/", f.name, f.premium);
    });

    return ResourceSearchResult(
      resources,
      result.isExactMatch,
      result.currentPage,
      result.hasNextPage
    );
  } catch (err) {
    console.log(err);
  }
}

export const retrieveResourcesByName = async (
  token,
  name,
  category,
  page = 0,
  size = 5
) => {
  const params = new URLSearchParams();
  params.append("category", category);
  params.append("page", page);
  params.append("size", size);
  params.append("name", name);
  const url = `${RESOURCES_BASE_URL}/files/search?` + params.toString();
  const res = await fetch(url, {
    headers: { Authorization: token },
  });
  if (!res.ok) {
    return ResourceSearchResult([], true, 0, false);
  }
  const result = await res.json();
  return getResourceSearchResult(token, result);
};

export const loadResource = async (location, token) => {
  const url = await toDataURL(location, token);
  return Resource(url, location);
};

export const loadResourceByFileName = async (fileName, token) => {
  const location = `/resources/files/location/${fileName}/`;
  const url = await toDataURL(location, token);
  return Resource(url, location);
};

export const postResource = async (file, tags, category, token) => {
  const formData = new FormData();
  formData.append("files", file);
  formData.append("tags", tags);
  formData.append("category", category);
  const res = await fetch(`${RESOURCES_BASE_URL}/files`, {
    method: "POST",
    body: formData,
    headers: { Authorization: token },
  });
};
